import './index.scss';
import React from 'react';
import { renderRoutes } from 'react-router-config';
import { TabBar } from 'antd-mobile';
import { useHistory } from 'react-router';
import AnimatedRouter from 'react-animated-router';
import 'react-animated-router/animate.css';
import sysConfig from '../sysConfig';
import { checkLogin } from '@/utils';

function BasicLayout({ location, route }) {
  const { preRouteUrl } = sysConfig;
  const history = useHistory();
  if (location.pathname === preRouteUrl || location.pathname === '/') {
    window.location.href = `${preRouteUrl}/home`;
  }
  const menus = [
    { key: 'home', title: '首页' },
    { key: 'personal', title: '我的' },
  ];
  const active = location.pathname.split('/')[2];
  return (
    <div className="basic-layout">
      <div className="main-content">
        <AnimatedRouter timeout={230}>{renderRoutes(route.routes)}</AnimatedRouter>
      </div>
      <TabBar tabBarPosition="bottom">
        {menus.map((item) => (
          <TabBar.Item
            key={item.key}
            icon={<em className={`tabBar-icon ${item.key}`} />}
            selectedIcon={<em className={`tabBar-icon ${item.key} active`} />}
            title={item.title}
            selected={active === item.key}
            onPress={() => {
              if (item.key === 'personal') {
                checkLogin({
                  onLogin: () => {
                    history.push(`${preRouteUrl}/${item.key}`);
                  },
                });
              } else {
                history.push(`${preRouteUrl}/${item.key}`);
              }
            }}
          />
        ))}
      </TabBar>
    </div>
  );
}

export default BasicLayout;
